import React from 'react';

function Footer() {
    return (
        <div className="footer">
            <p>⭯ <a href="https://dev.azure.com/ExergyManagementLab/_git/Outlook2SageX">2.4.0</a> / Octobre 2024 - ✉ <a href="mailto:francois.brouchoud@hevs.ch">francois.brouchoud@hevs.ch</a></p>
        </div>
    );
}

export default Footer;
